module.exports = __webpack_public_path__ + "img/ic_doc.b6251c30.svg";